<div class="modal-container d-flex flex-column" (isEnglish)="isEnglish = $event">
  <div class="modal-header bg-header justify-content-between align-items-center w-100" mat-dialog-header>
    <h1 class="m-0 p-0 font-20 text-dark fw-bold w-100" mat-dialog-title>
      {{ "FIELDS.PAYMENT_METHODS" | translate }}
    </h1>
  </div>

  <div class="p-4 m-0" mat-dialog-content>
    @if (showCardNumberForm) {
      <form class="d-flex flex-column gap-3" [formGroup]="cardNumberForm">
        <app-checkbox label="FIELDS.BANK_MUSCAT" formControlName="withBankMuscat" />

        @if (withBankMuscat) {
          <div class="d-flex align-items-center gap-2" [class.justify-content-end]="!isEnglish" dir="ltr">
            <mat-form-field appearance="outline" class="enhance-ui w-25 h-40" [dir]="isEnglish ? 'ltr' : 'rtl'">
              <input matInput class="h-100" placeholder="123456" maxlength="6" minlength="6" formControlName="prefix" />
            </mat-form-field>

            <span class="fw-bold">XX XXXXXX</span>

            <mat-form-field appearance="outline" class="enhance-ui w-25 h-40" [dir]="isEnglish ? 'ltr' : 'rtl'">
              <input matInput class="h-100" placeholder="1234" maxlength="4" minlength="4" formControlName="postFix" />
            </mat-form-field>
          </div>
        }
      </form>
    } @else {
      <p class="m-0 font-14">{{ "FIELDS.PAYMENT_METHODS_PLACEHOLDER" | translate }}</p>
    }
  </div>

  <div class="modal-footer w-100 d-flex justify-content-start gap-3" mat-dialog-actions>
    @if (!showCardNumberForm) {
      @for (paymentMethod of allPaymentMethods; track $index) {
        @if (paymentMethod === PaymentMethod.Cash) {
          <app-button btnLabel="ACTIONS.PAY_CASH" btnClass="btn-outline primary" (onClick)="matDialogRef.close(PaymentMethod.Cash)" />
        } @else if (paymentMethod === PaymentMethod.SwapMachine) {
          <app-button
            btnLabel="ACTIONS.PAY_SWAP"
            btnClass="btn-outline primary"
            (onClick)="matDialogRef.close(PaymentMethod.SwapMachine)"
          />
        } @else if (paymentMethod === PaymentMethod.Online) {
          <app-button btnLabel="ACTIONS.PAY_ONLINE" btnClass="btn-outline primary" (onClick)="showCardNumberForm = true" />
        }
      }

      <app-button btnLabel="ACTIONS.CANCEL" color="warn" (onClick)="matDialogRef.close(false)" />
    } @else {
      <app-button btnLabel="ACTIONS.PAY" color="primary" (onClick)="onSubmit()" [disabled]="cardNumberForm.invalid && !!withBankMuscat" />

      <app-button btnLabel="ACTIONS.CANCEL" color="warn" (onClick)="showCardNumberForm = false; cardNumberForm.reset()" />
    }
  </div>
</div>
